'use client';

import React, { FC, useState, useEffect } from 'react';
import { ClipboardIcon, ShareIcon } from '@heroicons/react/24/outline';
import { XMarkIcon as CloseIcon } from '@heroicons/react/24/solid';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import {
  FacebookShareButton,
  WhatsappShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  EmailShareButton,
  FacebookIcon,
  WhatsappIcon,
  TwitterIcon,
  LinkedinIcon,
  EmailIcon,
} from 'react-share';
import { PROJECT_SHARED } from '@/helpers/constants/events';
import useAccount from '@/lib/hooks/useAccount';

const ShareProjectPopup: FC<any> = ({ shareLink, show, onClose }) => {
  const [copySuccess, setCopySuccess] = useState(false);
  const {account} = useAccount();

  useEffect(() => {
    if (typeof window === 'undefined') return;

    if (show) {
      const scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    } else {
      const scrollY = document.body.style.top;
      const scrollPosition = scrollY ? parseInt(scrollY.replace('px', '')) * -1 : 0;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      requestAnimationFrame(() => {
        window.scrollTo(0, scrollPosition);
      });
    }

    return () => {
      if (typeof window === 'undefined') return;
      const scrollY = document.body.style.top;
      const scrollPosition = scrollY ? parseInt(scrollY.replace('px', '')) * -1 : 0;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      if (scrollPosition > 0) {
        requestAnimationFrame(() => {
          window.scrollTo(0, scrollPosition);
        });
      }
    };
  }, [show]);

  const handleCopy = () => {
    setCopySuccess(true);
    setTimeout(() => setCopySuccess(false), 2000);
    if (typeof window === "undefined") return;
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
      event: PROJECT_SHARED,
      userId: account?.accountId,
      projectUrl: shareLink,
      platform: 'copy',
    });
  };
    const handleSocialShare = (platform:string)=> {
    if (typeof window === "undefined") return;
    if(platform === 'Email'){
      window.location.href = encodeURI(`mailto:
        ?subject=Share Link
        &body=Link: ${shareLink}`);  
    }
    (window as any).dataLayer = (window as any).dataLayer || [];
    (window as any).dataLayer.push({
      event: PROJECT_SHARED,
      projectUrl: shareLink,
      userId: account?.accountId,
      platform
    });
  };
  return (
    <div>
      {show && (
        <div
          className="shadow fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[60] px-20 md:px-0"
          tabIndex={-1}
          style={{
            backgroundColor: 'rgba(0,0,0,0.4)',
            backdropFilter: 'blur(4px)',
          }}
        >
          <div className="max-w-[500px] bg-white rounded py-[18px] w-full">
            <div className="">
              <div className="flex items-center justify-between px-[18px] pb-[18px] border-b border-gray-300">
                <div className="flex align-items-center">
                  <ShareIcon className="w-[18px]" />
                  <h5 className="mb-0" style={{ fontWeight: '400', marginLeft: '8px' }}>
                    Share link
                  </h5>
                </div>

                <div onClick={onClose} style={{ cursor: 'pointer' }}>
                  <CloseIcon className="w-[20px]" />
                </div>
              </div>

              <div className="px-[18px] pt-[18px]">
                <div className="relative block copy-share-link w-full truncate rounded-full bg-[#E5E7EB] py-[8px] pl-[16px] pr-[33px]">
                  {shareLink}
                  <div className="absolute clipboard-copy">
                    <CopyToClipboard text={shareLink} onCopy={handleCopy}>
                      <ClipboardIcon className="w-[20px]" />
                    </CopyToClipboard>
                  </div>
                </div>

                {copySuccess && (
                  <div className="text-green-500" style={{ fontSize: '12px', paddingLeft: '8px', paddingTop: '4px' }}>
                    Link copied to clipboard!
                  </div>
                )}
                <div>
                  <div>
                    <h5 className="mt-[16px]" style={{ fontWeight: '400' }}>
                      Share using:
                    </h5>
                    <div className="flex mt-[12px] gap-[2px]">
                      <FacebookShareButton url={shareLink} onClick={()=>handleSocialShare('facebook')}>
                        <FacebookIcon size={40} round={true} />
                      </FacebookShareButton>

                      <WhatsappShareButton url={shareLink} onClick={()=>handleSocialShare('Whatsapp')}>
                        <WhatsappIcon size={40} round={true} />
                      </WhatsappShareButton>

                      <TwitterShareButton url={shareLink} onClick={()=>handleSocialShare('Twitter')}>
                        <TwitterIcon size={40} round={true} />
                      </TwitterShareButton>

                      <LinkedinShareButton url={shareLink} onClick={()=>handleSocialShare('Linkedin')}>
                        <LinkedinIcon size={40} round={true} />
                      </LinkedinShareButton>

                      <EmailShareButton url={shareLink} onClick={()=>handleSocialShare('Email')}>
                        <EmailIcon size={40} round={true} />
                      </EmailShareButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShareProjectPopup;
